export const nevada = {
  "32000": "Nevada",
  "32001": "Churchill County",
  "32003": "Clark County",
  "32005": "Douglas County",
  "32007": "Elko County",
  "32009": "Esmeralda County",
  "32011": "Eureka County",
  "32013": "Humboldt County",
  "32015": "Lander County",
  "32017": "Lincoln County",
  "32019": "Lyon County",
  "32021": "Mineral County",
  "32023": "Nye County",
  "32027": "Pershing County",
  "32029": "Storey County",
  "32031": "Washoe County",
  "32033": "White Pine County",
  "32510": "Carson City",
};
